import {
  MaterialStorage,
  MaterialType,
  useCurrentMaterialStorages,
  isStorageWithMaterialGuard
} from '@domain/material-storage'
import {useUpmPlantContext} from '@hconnect/upm'

interface SelectorParams {
  storages: MaterialStorage[]
  materialType?: MaterialType
}

const selector = ({storages, materialType}: SelectorParams) => {
  const storagesWithMaterial = storages
    .filter(isStorageWithMaterialGuard)
    .filter((storage) => (materialType ? storage.materialType === materialType : true))

  return [...new Set(storagesWithMaterial?.map(({materialId}) => materialId) ?? [])]
}

interface StoredMaterialIdsQueryParams {
  materialType?: MaterialType
}

export const useStoredMaterialIdsQuery = ({materialType}: StoredMaterialIdsQueryParams) => {
  const {plantId: plantCode} = useUpmPlantContext()
  return useCurrentMaterialStorages({
    plantId: plantCode,
    options: {select: (data) => selector({storages: data, materialType}), throwOnError: true}
  })
}
